import React from 'react';
import { QuestionCircleOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { Outlet, useLocation } from 'react-router-dom';
import { QueryParamProvider } from 'use-query-params';
import { ReactRouter6Adapter } from 'use-query-params/adapters/react-router-6';
import { AntdCol, AntdGrid, COLOR_BASE_100, useTheme } from '@ui';

import './layout.css';

const { useBreakpoint } = AntdGrid;

const b2bUrls = [/\/b2b\/sign-up/, /\/?trial-invite/];

export const PublicPageLayout: React.FC = () => {
  const { sm } = useBreakpoint();
  const { t } = useTranslation();
  const { bgColor } = useTheme();
  const { pathname } = useLocation();

  const isB2bUrl = b2bUrls.some((url) => url.test(pathname));

  return (
    <QueryParamProvider adapter={ReactRouter6Adapter}>
      <div
        style={{ backgroundColor: sm ? bgColor : COLOR_BASE_100 }}
        className="flex items-start md:items-center min-h-screen"
      >
        <AntdCol xs={0} sm={4} md={4} lg={4} xl={4} xxl={4} />
        <AntdCol xs={24} sm={16} md={16} lg={20} xl={20} xxl={20}>
          <Outlet />

          <div className="hidden sm:flex gap-4 items-center my-6">
            {!isB2bUrl && (
              <a
                href={t('faq.link')}
                target="_blank"
                rel="noopener noreferrer"
                className="text-base-100 flex items-center gap-1"
              >
                {t('faq.text')}
                <QuestionCircleOutlined />
              </a>
            )}
          </div>
        </AntdCol>
        <AntdCol xs={0} sm={4} md={4} lg={0} xl={0} xxl={0} />
      </div>
    </QueryParamProvider>
  );
};
